module.exports = __webpack_public_path__ + "static/media/alert-triangle.ede82f59.svg";